import { Pipe, PipeTransform } from '@angular/core';
import { FilesAndSuggestionsPluginService } from './filesandsuggestions-plugin.service';

@Pipe({
    name: 'fileAndSuggestionToType',
    standalone: false
})
export class FileAndSuggestionToTypePipe implements PipeTransform {
  public toTypes: any;

  constructor(private service: FilesAndSuggestionsPluginService) {
    this.toTypes = this.service.getToTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.toTypes);
  }
}
